// extracted by mini-css-extract-plugin
export default {"keyboardRow":"Keyboard_keyboardRow__ws4IL","key":"Keyboard_key__9fyEl","wrongKey":"Keyboard_wrongKey__88ud9"};